module.exports = __webpack_public_path__ + "img/scene4.50a45f24.webp";